export const settingKeys = {
  NATION_ALL: () => ['nation'],
  NATION_MOBILE: (mobile?: boolean) => ['nation', 'mobile', mobile],
};
